"use client";

import ScrollReveal from "./ScrollReveal";

const ROWS = [
  { label: "Context sent", typical: "Whole files", mc: "Relevant slices only" },
  { label: "Repeated context", typical: "Re-sent every call", mc: "~90% served from cache" },
  { label: "Session length before degradation", typical: "Short", mc: "100+ messages" },
  { label: "Cost per frontier request", typical: "Higher", mc: "~$0.06 measured" },
  { label: "Frontier runs on a $20 plan", typical: "Fewer", mc: "300+" },
];

export default function TokenEfficiency() {
  return (
    <section className="py-16 lg:py-20">
      <div className="max-w-4xl mx-auto px-6">
        <ScrollReveal>
          <div className="text-center mb-10">
            <div
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-wider mb-5"
              style={{
                background: "rgba(16,185,129,0.04)",
                color: "var(--mc-emerald)",
                border: "1px solid rgba(16,185,129,0.1)",
              }}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--mc-emerald)]" />
              Every token pulls its weight
            </div>
            <h2 className="text-[clamp(1.8rem,4vw,2.8rem)] font-black tracking-tight mb-3 leading-[1.1]">
              The same $20 buys{" "}
              <span className="hero-gradient-text">more here.</span>
            </h2>
            <p className="text-[15px] text-(--text-secondary) max-w-2xl mx-auto leading-relaxed">
              Most AI editors send whole files to the model. MonkeysCode sends the relevant slices,
              resolved locally by an on-device index that understands your codebase structure.
              The difference compounds.
            </p>
          </div>

          <div className="premium-card overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-[14px]">
                <thead>
                  <tr style={{ background: "rgba(15,23,42,0.02)" }}>
                    <th className="text-left py-3 px-5 font-bold text-(--text-muted) text-[12px] uppercase tracking-wider" />
                    <th className="text-center py-3 px-5 font-bold text-(--text-muted) text-[12px] uppercase tracking-wider">Typical AI editor</th>
                    <th className="text-center py-3 px-5 font-bold text-[12px] uppercase tracking-wider" style={{ color: "var(--mc-emerald)" }}>MonkeysCode</th>
                  </tr>
                </thead>
                <tbody>
                  {ROWS.map((row) => (
                    <tr key={row.label} className="border-t" style={{ borderColor: "var(--border)" }}>
                      <td className="py-3 px-5 font-medium text-[13px]">{row.label}</td>
                      <td className="py-3 px-5 text-center text-(--text-secondary) text-[13px]">{row.typical}</td>
                      <td className="py-3 px-5 text-center font-semibold text-[13px]" style={{ color: "var(--mc-emerald)" }}>{row.mc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <p className="text-center text-[13px] text-(--text-secondary) mt-6 max-w-2xl mx-auto leading-relaxed">
            Everyday work runs on unlimited Capuchin. Frontier tokens are spent only on problems that
            deserve them. That is why a $20 plan here goes further than a $20 plan elsewhere.
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}
